import { CellContext } from "@tanstack/react-table";
import type { ViewTableFeatures } from "@design-system/ViewTable/core/table";
import { memo } from "react";
import { getAccountingBasisLabel } from "@common/helpers/accountingBasis";
import { EmptyValue } from "@design-system/EmptyValue/EmptyValue";
import { ViewTableCell } from "@design-system/ViewTable/ViewTableCell";
import { ChartOfAccountsTemplateRow } from "../chartOfAccountsTemplatesViewConfig";

export const ChartOfAccountsTemplateBasisCell = memo(
    ({
        row,
    }: CellContext<ViewTableFeatures, ChartOfAccountsTemplateRow, unknown>) => {
        const { basis } = row.original;

        return (
            <ViewTableCell>
                {basis.length > 0 ? (
                    <span className="text-secondary text-truncate">
                        {basis.map(getAccountingBasisLabel).join(", ")}
                    </span>
                ) : (
                    <EmptyValue />
                )}
            </ViewTableCell>
        );
    },
);
